/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue } from 'vue-property-decorator'
import { setCustomerBusinessFollow, getCustomerBusinessFollowListByCustomerBusinessId } from '@/api/customer'
import dUploadFile from '@/components/uploadFile/index.vue'
import {formatDate} from "@/utils/timeFilter";
import {Loading} from "element-ui";
import {uploadFile} from '@/api/common'
import axios from "axios";
@Component({
    components: { dUploadFile }
})
export default class Fllow extends Vue {
    fileList: { name: string; url: string }[] = []
    tableData = []
    page = 1
    limit = 20
    total = 0
    id: number
    name = ''
    customerBusinessId: number
    dialogImageUrl: string
    dialogVisible: boolean
    deadline: Date = null // 截止时间
    time = null
    datePickerOptions = {
        disabledDate: (v: Date) => (true),
    }
    timePickerOptions = { start: '00:00', step: '01:00', end: "23:59" }
    startDate: Date = null
    endDate: Date = null // 计算得出最后的结束时间为什么时候
    flag = false // 是否修改过时间没如果修改过就给后台传值
    disBtn = false
    formModel = {
        intention: '',
        textValue: ''
    }
    formRules = {
        intention: [{ required: true, message: '请选择购买意向', trigger: 'change' }],
        textValue: [{ required: true, message: '请输入跟进内容', trigger: 'blur' }],
    }
    axios = null

    created() {
        this.$nextTick(() => {
            (this.$refs['el-table'] as HTMLFormElement).bodyWrapper.addEventListener('scroll', (res: any) => {
                const height = res.target;
                const clientHeight = height.clientHeight;
                const scrollTop = height.scrollTop;
                const scrollHeight = height.scrollHeight;
                if (clientHeight + scrollTop >= scrollHeight) {
                    if (this.tableData.length >= this.total) {

                        return
                    }
                    this.limit += 20
                }
            }, true);
        })

        // 拿到当前转化客户的id
        this.customerBusinessId = Number(this.$route.query.id)
        this.name = this.$route.query.name as string
        this.getTableData()
        this.createAxios()
    }
    /**/
    mounted() {
        this.datePickerOptions.disabledDate = (v: Date) => {
            const emun = {'高': 1, '中': 3, '低': 7,}
            const nowtime = v.getTime()
            const starttime = new Date().setHours(0, 0, 0, 0)
            const endtime = (new Date().getTime() + 1000 * 60 * 60 * 24 * emun[this.formModel.intention])
            this.startDate = new Date()
            if (!this.formModel.intention) {
                return true
            }
            if (this.formModel.intention === '已签约' || this.formModel.intention === '已拒绝' || this.formModel.intention === '暂无' || this.formModel.intention === '已退群/拉黑') {
                return !(v.setHours(0, 0, 0, 0) >= starttime)
            }
            this.endDate = new Date(endtime)
            return !(nowtime >= starttime && nowtime <= endtime)
        }
    }
    // methods

    deadlineChange() {
        // this.time = ''
        if(new Date(this.deadline).setHours(0,0,0,0) === new Date(this.startDate).setHours(0,0,0,0)) {
            this.timePickerOptions.start = `${this.startDate.getHours()}:${'00'}`
            this.timePickerOptions.end = '23:59'
        } else if(new Date(this.deadline).setHours(0,0,0,0) === new Date(this.endDate).setHours(0,0,0,0)) {
            this.timePickerOptions.start = '00:00'
            this.timePickerOptions.end = `${this.endDate.getHours()}:${'00'}`
            // this.timePickerOptions.end = `${this.endDate.getHours()}:${this.endDate.getMinutes()}`
        } else {
            this.timePickerOptions.start = '00:00'
            this.timePickerOptions.end = '23:59'
        }
    }

    confirm() {
        (this.$refs.dynamicValidateForm as HTMLFormElement).validate((valid: boolean) => {
            if(valid) {
                // if (this.formModel.intention === '') {
                //     this.$message.error('请选择购买意向')
                //     return;
                // }

                if (!(this.deadline && this.time)) {
                    this.$message.error('请选择跟进截止时间')
                    return;
                }

                // if (this.formModel.textValue === '') {
                //     this.$message.error('请填写跟进内容')
                //     return;
                // }

               this.disBtn = true
               setCustomerBusinessFollow({
                    customerBusinessId: this.customerBusinessId,
                    content: this.formModel.textValue,
                    followAt: formatDate('yyyy-MM-dd', new Date(this.deadline)) + ' ' + (this.time ? this.time : '00:00'),
                    intention: this.formModel.intention,
                })
                this.$message.success('新增跟进记录成功')
                this.getTableData()
                this.formModel.textValue = ''
                this.disBtn = false
            }
        })


    }
    async getTableData() {
        const data: any = await getCustomerBusinessFollowListByCustomerBusinessId({
            customerBusinessId: this.customerBusinessId,
            limit: this.limit,
            page: this.page
        })
        this.total = data.allNum
        this.tableData = data.customerBusinessFollowList
        this.tableData = this.tableData.map((item: any) => ({ ...item, isEdit: false }))
    }

    async confirmEdit(row: any) {
        await setCustomerBusinessFollow({
            id: row.id,
            content: row.content,
            customerBusinessFollowDataList: [...row.customerBusinessFollowDataList, ...this.fileList],
            // followAt: row.createdAt,
            // intention: row.intention,
        })
        this.$message.success('保存成功')
        row.isEdit = false
        this.fileList = []
    }

    clickEditbtn(row: any) {
        const bol = this.tableData.some(item => item.isEdit)
        if (bol) {
            this.$message({
                type: 'error',
                message: '请先将其它处于编辑状态的跟进记录保存后在开启新的编辑',
                duration: 3000
            })
            return
        }
        this.id = row.id
        row.isEdit = true
    }

    handleUploadSuccess(res, file, fileList) {
        if (res.error.returnCode !== 0) {
            this.$message.error(`上传失败，${res.error.returnMessage}`)
            return
        }
        this.$message.success('上传成功')
        this.fileList.push({ name: file.name, url: res.data.ossUrl })
    }
    handleUploadError() {
        this.$message.error('上传失败')
    }
    handleUploadRemove(file, fileList) {
        this.tableData.forEach(item => {
            if(item.id === this.id) {
                item.customerBusinessFollowDataList = fileList
            }
        })
    }

    createAxios() {
        const origin = location.hostname; //当前访问域名
        let requestBase = "";
        if (process.env.NODE_ENV === "development") {
            requestBase = process.env.VUE_APP_BASE_FILE_API_PROXY;
        } else {
            if (origin.indexOf("-testserver") > -1) {
                requestBase = process.env.VUE_APP_DEV_FILE_API;
            } else {
                requestBase = process.env.VUE_APP_MASTER_FILE_API;
            }
        }
        const config = {
            baseURL: requestBase,
            timeout: 30 * 1000, // Timeout
        };
        this.axios = axios.create(config);
    }
    async uploadFile(row: any, e: any) {
        const loading = Loading.service({ text: '正在上传文件' })
        const file = e.target.files[0]
        const formdata = new FormData()
        formdata.append('file', file, file.name)
        formdata.append('bucket', 'crm')
        this.axios.post(
            "/upload/upload",
            formdata
        ).then(res => {
            const data: any = res.data.data
            row.customerBusinessFollowDataList.push({
                name: data.name,
                url: data.ossUrl
            })
            this.$nextTick(() => {
                loading.close()
            })
        }).catch(error=>{
            console.log(error)
        })
    }

    delFile(row: any, index: number) {
        row.splice(index, 1)
    }

    intentionalityChange(val: string) {
        this.deadline = new Date(new Date());
        const arr = ['已签约', '已拒绝', '暂无', '已退群/拉黑']
        if(!arr.includes(this.formModel.intention)) {
            if(val === '高') this.deadline = new Date(new Date().getTime() + (1000 * 60 * 60 * 24)); this.endDate = this.deadline
            if(val === '中') this.deadline = new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 3)); this.endDate = this.deadline
            if(val === '低') this.deadline = new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 7)); this.endDate = this.deadline
            this.$nextTick(() => {
                this.time = this.endDate.getHours() + ':' + '00'
            })
            this.deadlineChange()
        } else {
            this.deadline = new Date(new Date());
            this.time = new Date().getHours() + ':' + '00'
        }
    }
}
